<template>
  <div>
    <b-card no-body>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="search-section"
        >
          <div class="p-4">
            <search-product
              ref="searchProduct"
              :advance="false"
              :limit="10"
              shadow-item
              scroll
              selected-indicator
              load-more
              @on-select="onSelect"
            >
              <template #emptyState>
                <div class="my-4 text-center">
                  <h4>Cari Produk di sini</h4>
                  <p>Pastikan produk yang dipilih tidak memiliki merchant yang sama dengan merchant tujuan anda.</p>
                </div>
              </template>
            </search-product>
          </div>
        </b-col>
        <!-- Merchant -->
        <b-col
          cols="12"
          md="6"
          class="result-section"
        >
          <div class="p-4">
            <div class="header-result">
              <b-row align-v="center">
                <b-col>
                  <h5>Produk Terpilih ({{ selectedProduct.length }})</h5>
                </b-col>
                <b-col cols="auto">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    :disabled="!selectedProduct.length"
                    @click="isSubmit = true"
                  >
                    Lanjutkan
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <hr>
            <div
              v-if="selectedProduct.length"
            >
              <div
                v-for="(item, index) in selectedProduct"
                :key="`list-product-${index}`"
              >
                <b-row align-v="center">
                  <b-col cols="auto">
                    <b-button
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="flat-danger"
                      class="btn-icon rounded-circle"
                      @click="onUnSelect(item)"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-col>
                  <b-col>
                    <ProductItem
                      :img="item.images.length ? item.images[0].image_url : ''"
                      :title="item.name"
                      :subtitle="`by ${item.merchant.name}`"
                      :badge="''"
                      :price="toCurrency(item.price ? item.price : 0)"
                      :opacity="1"
                      :hoverable="false"
                    />
                  </b-col>
                </b-row>
                <hr v-if="index+1 !== selectedProduct.length">
              </div>
            </div>
            <div
              v-else
              class="text-center my-4"
            >
              <p class="text-muted">
                Belum ada produk yang dipilih.
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      v-model="isSubmit"
      title="Transfer Produk"
      no-close-on-backdrop
    >
      <div>
        <b-form-group
          label="Merchant Tujuan"
          label-for="input-merchant"
        >
          <v-select
            id="input-merchant"
            v-model="form.merchant"
            input-id="input-merchant"
            label="name"
            :loading="isSearchingMerchant"
            :options="dataBrand"
            :filterable="false"
            placeholder="Pilih merchant tujuan"
            @search="onSearchMerchant"
          >
            <template #option="{ name }">
              {{ name }}
            </template>
            <!-- eslint-disable-next-line vue/no-unused-vars  -->
            <template #no-options="{ search, searching, loading }">
              <span v-if="searching">
                "{{ search }}" tidak ditemukan.
              </span>
              <span v-else>
                Cari Merchant...
              </span>
            </template>
          </v-select>
        </b-form-group>
        <hr>
        <div>
          <div
            v-for="(item, index) in selectedProduct"
            :key="`list-product-modal-${index}`"
          >
            <ProductItem
              v-if="index <= 2"
              :img="item.images.length ? item.images[0].image_url : ''"
              :title="item.name"
              :subtitle="`by ${item.merchant.name}`"
              :badge="''"
              :price="toCurrency(item.price ? item.price : 0)"
              :opacity="1"
              :hoverable="false"
              class="mb-1"
            />
          </div>
          <div
            v-show="selectedProduct.length > 3"
            class="text-center pb-2 pt-1 text-muted"
          >
            dan {{ selectedProduct.length - 3 }} Produk lainnya
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          :disabled="!form.merchant || isSubmiting"
          @click.prevent="onSubmit"
        >
          <b-spinner
            v-if="isSubmiting"
            small
            label="Spinning"
          />
          {{ !isSubmiting ? `Transfer ${selectedProduct.length} Produk` : 'Mentransfer' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BCard,
  BButton,
  BSpinner,
} from 'bootstrap-vue'

// Vee Validate
import vSelect from 'vue-select'
import { mapState, mapActions } from 'vuex'
import SearchProduct from '@/layouts/components/custom/SearchProduct.vue'
import ProductItem from '@/layouts/components/custom/ProductItem.vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'ProductInfoForm',
  components: {
    BButton,
    BFormGroup,
    BRow,
    BCol,
    vSelect,
    BCard,
    SearchProduct,
    ProductItem,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      isSearchingMerchant: false,
      form: {
        merchant: '',
      },
      selectedProduct: [],
      isSubmit: false,
      isSubmiting: false,
    }
  },
  computed: {
    ...mapState('brand', ['brandList']),
    dataBrand() {
      return this.brandList.data
    },
  },
  created() {
    this.$store.commit('products/RESET_PRODUCT_SEARCH')
    this.$store.commit('products/RESET_PRODUCT_SEARCH_META')
  },
  methods: {
    ...mapActions('brand', ['getBrandList']),
    ...mapActions('products', ['switchProductMerchant']),
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      return response
    },
    async onSearchMerchant(text, loading) {
      if (text.length) {
        this.isSearchingMerchant = true
        loading(true)
        await this.getBrandList({ page: 1, keyword: text })
      }

      this.isSearchingMerchant = false
    },
    async onSelect(data) {
      this.selectedProduct.push(data)
    },
    async onUnSelect(data) {
      const index = await this.$refs.searchProduct.onUnPickProduct(data)
      this.selectedProduct.splice(index, 1)
    },
    async onSubmit() {
      this.isSubmiting = true
      const merchantId = await this.form.merchant.id
      const productId = await this.selectedProduct.map(el => el.id)

      const isHaveSameMerchant = this.selectedProduct.filter(el => el.merchant.id === merchantId)

      if (isHaveSameMerchant.length) {
        this.$bvModal
          .msgBoxConfirm('Produk yang anda pilih memiliki merchant yang sama dengan merchant tujuan.', {
            title: 'Perhatian',
            size: 'sm',
            okVariant: 'primary',
            okTitle: 'Hapus dan lanjutkan',
            cancelTitle: 'Kembali',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          })
          .then(async value => {
            if (value) {
              this.selectedProduct = await this.selectedProduct.filter(el => el.merchant.id !== merchantId)
              this.isSubmit = await true
              this.onSubmit()
            }
          })
      } else {
        await this.switchProductMerchant({ merchantId, productId })
        this.isSubmiting = await false
        this.isSubmit = await false

        this.$router.push('/products')
        this.$store.commit('products/RESET_PRODUCT_SEARCH')
        this.$store.commit('products/RESET_PRODUCT_SEARCH_META')
      }
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
::v-deep .vs__actions {
    .vs__clear {
        visibility: hidden;
    }
}

.search-section {
    background-color: #f8f8f8;
}

.result-section {
    align-self: start;
    position: -webkit-sticky;
    position: sticky;
    top: 50px;
    z-index: 11;
}

.header-result {
  position: sticky;
  width: 100%;
  top: 100px;
  z-index: 11;
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 31px 14px rgba(255,255,255,1);
  -moz-box-shadow: 0px 0px 31px 14px rgba(255,255,255,1);
  box-shadow: 0px 0px 31px 14px rgba(255,255,255,1);
}

.dark-layout {
  .header-result {
    background-color: #283046;
    -webkit-box-shadow: 0px 0px 31px 14px rgba(40,48,70,1);
    -moz-box-shadow: 0px 0px 31px 14px rgba(40,48,70,1);
    box-shadow: 0px 0px 31px 14px rgba(40,48,70,1);
  }

  .search-section {
    background-color: #384056;
  }
}
</style>
